import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    ismobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    newProjectLogic: localStorage.getItem("newProjectLogic") || true,
    deviceMode: localStorage.getItem("deviceMode") || "",
    terminalMode: localStorage.getItem("terminalMode") || "",
    timeoutTimer: localStorage.getItem("timeoutTimer") || 15,
    firstRun: localStorage.getItem("firstRun") || true,
    lastStatusPresenceList: localStorage.getItem("lastStatusPresenceList") || ""
  },
  mutations: {
    setFirstRun(state, newVal) {
      state.firstRun = newVal;
    },
    setSettings(state, settings) {
      state.firstRun = settings.firstRun;
      state.deviceMode = settings.deviceMode;
      state.terminalMode = settings.terminalMode;
      state.timeoutTimer = settings.timeoutTimer;
      state.newProjectLogic = settings.newProjectLogic;
    },
    setLastStatusPresencelist(state, status) {
      state.lastStatusPresenceList = status;
    }
  },
  actions: {
    setFirstRun({ commit }, val) {
      localStorage.setItem("firstRun", true);
      commit("setFirstRun", val);
    },
    setSettings({ commit }, settings) {
      localStorage.setItem("firstRun", settings.firstRun);
      localStorage.setItem("deviceMode", settings.deviceMode);
      localStorage.setItem("terminalMode", settings.terminalMode);
      localStorage.setItem("timeoutTimer", settings.timeoutTimer);
      localStorage.setItem("newProjectLogic", settings.newProjectLogic);

      commit("setSettings", settings);
    },
    setLastStatusPresencelist({ commit }, status) {
      localStorage.setItem("lastStatusPresenceList", status);
      commit("setLastStatusPresencelist", status);
    }
  },
  modules: {},
  getters: {
    isMobile: (state) => state.ismobile,
    firstRun: (state) => state.firstRun,
    deviceMode: (state) => state.deviceMode,
    terminalMode: (state) => state.terminalMode,
    timeoutTimer: (state) => state.timeoutTimer,
    newProjectLogic: (state) => state.newProjectLogic,
    lastStatusPresenceList: (state) => state.lastStatusPresenceList
  }
};
